    import React from 'react';

    // Opcionális: Ha van egy központi CSS fájlod, vagy CSS modulokat használsz,
    // importáld a stílusokat itt.
    // import './AccountDeletionPage.css'; 

    const AccountDeletionPage = () => {
        return (
            <div className="account-deletion-container" style={{ fontFamily: 'sans-serif', lineHeight: '1.6', margin: '20px auto', maxWidth: '800px', padding: '15px', border: '1px solid #ddd', borderRadius: '5px', backgroundColor: '#f9f9f9' }}>
                <h1 style={{ color: '#B71C1C' }}>ArcheryNexus - Fiók és Adatok Törlése</h1>

                <p>Az ArcheryNexus felhasználói bármikor kérhetik fiókjuk és a hozzájuk kapcsolódó személyes adatok törlését. Kérjük, kövesse az alábbi lépéseket:</p>

                <h2>Fióktörlés az alkalmazáson keresztül (Ajánlott):</h2>
                <ol>
                    <li>Nyissa meg az ArcheryNexus alkalmazást a készülékén.</li>
                    <li>Navigáljon a "Profil" fülre/képernyőre.</li>
                    <li>Keresse meg és kattintson a "Fiók törlése" gombra.</li>
                    <li>Egy megerősítő üzenet jelenik meg. Olvassa el figyelmesen, majd kattintson a "Törlés" gombra a művelet véglegesítéséhez.</li>
                </ol>
                <p>A törlés megerősítését követően fiókja és a hozzá kapcsolódó adatok azonnal törlésre kerülnek rendszereinkből.</p>

                <h2>Alternatív fióktörlési kérelem (E-mailben):</h2>
                <p>Amennyiben nem tudja használni az alkalmazáson belüli törlési funkciót, kérjük, küldjön egy e-mailt a következő címre: <strong>[robert.marki@live.com]</strong></p>
                <ul>
                    <li>Az e-mail tárgya legyen: <code>ArcheryNexus Fióktörlési Kérelem</code></li>
                    <li>Az e-mailben kérjük, adja meg azt az e-mail címet, amellyel az ArcheryNexus fiókját regisztrálta.</li>
                </ul>
                <p>E-mailes kérelem esetén a törlési folyamat [3-5 munkanapon belül] megtörténik, miután sikeresen azonosítottuk a fiókot.</p>

                <h2>Milyen adatok kerülnek törlésre?</h2>
                <p>A fióktörlési kérelem feldolgozását követően a következő, Önnel kapcsolatba hozható adatokat véglegesen töröljük rendszereinkből:</p>
                <ul>
                    <li>Regisztrált e-mail címe</li>
                    <li>Firebase felhasználói azonosítója (UID)</li>
                    <li>Minden Ön által rögzített edzésadat (lőttevékenységek, pontszámok, dátumok, helyszínek, jegyzetek stb.)</li>
                    <li>Profilbeállításai és egyéb, az alkalmazásban megadott személyes információk.</li>
                    {/* Adj hozzá bármi mást, ami specifikus az appodra */}
                </ul>

                <h2>Megőrzött adatok</h2>
                <p>Nem őrzünk meg személyesen azonosítható adatokat a fiókja törlése után. Kizárólag teljesen anonimizált, összesített statisztikai adatokat használhatunk fel az alkalmazás általános használatának elemzésére és fejlesztésére, amelyekből egyedi felhasználók nem azonosíthatók.</p>
                
                <p>Ha bármilyen kérdése van a fióktörlési folyamattal kapcsolatban, kérjük, vegye fel velünk a kapcsolatot a fenti e-mail címen.</p>

                <p><em>Utolsó frissítés: [2025. szeptember 1.]</em></p>
            </div>
        );
    };

    export default AccountDeletionPage;
    